import HttpService from "./htttp.service";

class FeaturesService {
  getFeatures = async (query, cancelToken) => {
    const endpoint = "users/features";
    return await HttpService.get(endpoint, query, cancelToken);
  };
}

export default new FeaturesService();
